import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import PopUpDialogBox from "../../../shared/PopUpDialogBox";
import { AppState } from "../../../store/rootReducer";
import { setWithDrawableAmount } from "../../../utils/localStorage";
import { logFirebaseEvent } from "../firebase";
import { P2P_ADD_MONEY_ND_BTN, P2P_FD_ADD_MONEY_BTN, P2P_WITHDRAW_BTN } from "../firebase/constant";
import ExistingUser from "./UsersDashboard/existingUser";
import NewUser from "./UsersDashboard/newUser";
import WithdrawalPopupImg from "../../../utils/assests/withdrawalPop.png";
function InvestmentBox() {
  let history = useHistory();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const { dashboardSummary } = useSelector(
    (state: AppState) => state.dashboard
  );

  const handleInvest = () => {
    logFirebaseEvent(P2P_ADD_MONEY_ND_BTN);
    logFirebaseEvent(P2P_FD_ADD_MONEY_BTN);
    history.push({
      pathname: "/p2p/addmoney",
    });
  };

  const handleWithdrawMoney = () => {
    setDialogOpen(true)
  };
  const handlePopupClose = () => {
    setDialogOpen(!dialogOpen);
  }

  const handleYes = () => {
    logFirebaseEvent(P2P_WITHDRAW_BTN);
    if (dashboardSummary?.status && (dashboardSummary?.data?.WithdrawableAmount > 0)) {
      setWithDrawableAmount(dashboardSummary?.data?.WithdrawableAmount)
      history.push({
        pathname:'/p2p/withdraw'
      })
      setDialogOpen(!dialogOpen);
    } else {
      setDialogOpen(!dialogOpen);
      history.push({
        pathname: '/p2p/withdrawal'
      })
    }
  }

  return (
    <>
      {dashboardSummary && dashboardSummary?.status && (dashboardSummary?.data.Investment.Total !== 0 || dashboardSummary?.data.RequestedInvestment !== 0)
        ? <ExistingUser
          addMoney={handleInvest}
          withdrawMoney={handleWithdrawMoney}
        />
        :
        <NewUser
          addMoney={handleInvest}
        />
      }
      <PopUpDialogBox
        toggle={dialogOpen}
        handleClose={handlePopupClose}
        image={WithdrawalPopupImg}
        handleYes={handleYes}
        buttonTitle="Yes"
        success={false}
      />
    </>
  );
}
export default InvestmentBox;